import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import PercentIcon from "@mui/icons-material/Percent";
import DownloadIcon from "@mui/icons-material/Download";
import { exportTable } from "../../../Utility/Utilitys";
const ItemVerfication = ({
  data,
  sDetailItemData,
  selectedPages,
  handleTogglePage,
  handleSelectAll,
  allSelected,
}) => {
  const uMediaQuery = useMediaQuery("(max-width:1250px)");

  const filterRowByHeaders = (row, columns) => {
    return columns.reduce((acc, col) => {
      acc[col.header] = row?.[col.key] ?? "";
      return acc;
    }, {});
  };

  const itemsColumns = [
    {
      key: "ItmCode",
      header: "Item Code",
      align: "left",
      width: 120,
      render: (row) => <Typography color="orchid">{row.ItmCode}</Typography>,
    },
    {
      key: "ItemName",
      header: "Item Name",
      align: "left",
      width: 180,
      // flex: 1, // will expand if space is available
      render: (row, col) => (
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            maxWidth: 180,
          }}
        >
          <InventoryIcon color="primary" fontSize="small" />
          <Tooltip title={row.ItemName} placement="bottom" arrow>
            <Typography
              marginLeft={"4px"}
              fontWeight={600}
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 150, // 180 - icon space
                display: "block",
              }}
            >
              {row.ItemName}
            </Typography>
          </Tooltip>
        </div>
      ),
    },
    {
      key: "Unit",
      header: "Unit",
      align: "left",
      width: 80,
      render: (row, col) =>
        row.Unit ? (
          <Chip
            label={row.Unit}
            variant="outlined"
            color="default"
            size="small"
            sx={{ borderRadius: "999px" }}
          />
        ) : (
          ""
        ),
    },
    {
      key: "RSP",
      header: "RSP",
      align: "right",
      width: 80,
      render: (row) => <Typography color="primary">{row.RSP}</Typography>,
    },
    {
      key: "RSPWithVat",
      header: "RSP-(VAT)",
      align: "right",
      minWidth: 80,
      render: (row) => (
        <Typography color="primary">{row.RSPWithVat}</Typography>
      ),
    },
    {
      key: "CutPrice",
      header: "Cut.Price",
      align: "right",
      minWidth: 80,
      render: (row) => <Typography color="error">{row.CutPrice}</Typography>,
    },
    {
      key: "DiscountPerc",
      header: "Disc.%",
      align: "right",
      width: 70,
      render: (row) => (
        <Typography color="success">{row.DiscountPerc}</Typography>
      ),
    },
    {
      key: "DiscountAmount",
      header: "Disc.Amt",
      align: "right",
      width: 80,
      render: (row) => (
        <Typography color="success">{row.DiscountAmount}</Typography>
      ),
    },
    {
      key: "PromoRSP",
      header: "Promo.RSP",
      align: "right",
      minWidth: 90,
      render: (row) => <Typography color="primary">{row.PromoRSP}</Typography>,
    },
    {
      key: "PromoRSPWithVat",
      header: "Promo.RSP-(VAT)",
      align: "right",
      minWidth: 120,
      render: (row) => (
        <Typography color="primary">{row.PromoRSPWithVat}</Typography>
      ),
    },
    {
      key: "QtyPerPromotion",
      header: "Qty/Inv",
      align: "center",
      minWidth: 60,
      render: (row) => (
        <Typography color="blue">{row.QtyPerPromotion}</Typography>
      ),
    },
    {
      key: "CNType",
      header: "CN Type",
      align: "left",
      minWidth: 80,
      render: (row, col) =>
        row.CNType ? (
          <Chip
            label={row.CNType}
            variant="outlined"
            color="default"
            size="small"
            sx={{ borderRadius: "999px" }}
          />
        ) : (
          ""
        ),
    },
    {
      key: "CNAmount",
      header: "CN.Amt",
      align: "right",
      minWidth: 60,
    },
    {
      key: "Vendor",
      header: "Vendor",
      align: "left",
      width: 80,
      render: (row) => (
        <Tooltip title={row.Vendor} placement="bottom" arrow>
          <Typography
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 110, // 180 - icon space
              display: "block",
            }}
          >
            {row.Vendor}
          </Typography>
        </Tooltip>
      ),
    },
    {
      key: "PromoTyp",
      header: "Type",
      align: "left",
      width: 80,
      render: (row, col) =>
        row.PromoTyp ? (
          <Chip
            label={row.PromoTyp}
            variant="outlined"
            color="default"
            size="small"
            sx={{ borderRadius: "999px" }}
          />
        ) : (
          ""
        ),
    },
    {
      key: "Remarks",
      header: "Remarks",
      align: "left",
      width: 130,
    },
  ];

  const cellSx = (col) => {
    const sx = {
      whiteSpace: "nowrap", // no wrapping
      overflow: "hidden", // hide overflow
      textOverflow: "ellipsis", // add ...
      maxWidth: col.width || col.minWidth || 120, // max width for ellipsis
      width: col.width,
    };
    if (col.width) sx.width = col.width; // px or %
    if (col.minWidth) sx.minWidth = col.minWidth; // px
    if (col.flex) sx.width = `${col.flex * 100}%`; // simple flex-like %
    return sx;
  };

  return (
    <Box py={1}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <Tooltip title="Export CSV">
          <span>
            <IconButton
              color="primary"
              onClick={() => {
                const exportData =
                  sDetailItemData?.pageData
                    ?.filter((page) => selectedPages.includes(page.RowId))
                    ?.flatMap((page) => [
                      // Page header row
                      {
                        PageHeader: page.Title,
                      },

                      // Page rows
                      ...(page.subData || []).map((item) => ({
                        TransId: item.TransId,
                        PageId: item.PageId,
                        ...filterRowByHeaders(item, itemsColumns),
                      })),

                      // Empty row between pages
                      {},
                    ]) || [];

                exportTable(exportData, "ItemVerify", "ItemVerify");
              }}
            >
              <DownloadIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      {uMediaQuery && (
        <Typography
          variant="subtitle2"
          fontWeight={600}
          sx={{ width: "140px" }}
        >
          Page selection:
        </Typography>
      )}
      <Box display="flex" justifyContent="space-between">
        <Box
          display="flex"
          gap={0}
          marginTop={1}
          marginLeft={uMediaQuery ? "10px" : "0px"}
        >
          {!uMediaQuery && (
            <Typography
              variant="subtitle2"
              fontWeight={600}
              sx={{ width: "140px" }}
            >
              Page selection:
            </Typography>
          )}

          {sDetailItemData?.pageData?.length > 0 ? (
            <FormGroup
              row
              sx={{
                gap: 1,
                "& .MuiCheckbox-root": {
                  padding: "2px 4px !important",
                },
              }}
            >
              {/* Select All */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allSelected}
                    onChange={handleSelectAll}
                    size="small"
                  />
                }
                label="Select All"
                sx={{ fontWeight: "bold" }}
              />

              {/* Divider */}
              <Box
                sx={{
                  width: "1px",
                  bgcolor: "#cbd5e1",
                }}
              />

              {/* Pages */}
              {sDetailItemData?.pageData?.map((page, index) => {
                // Condition 1: all subData items must be true
                const allRowsVerified =
                  page.subData?.length > 0 &&
                  page.subData.every((item) => item.IsVerify === true);

                return (
                  <FormControlLabel
                    key={page.RowId}
                    sx={{
                      "& .MuiCheckbox-root": {
                        color: allRowsVerified ? "green" : "",
                      },
                    }}
                    control={
                      <Checkbox
                        checked={selectedPages.includes(page.RowId)}
                        onChange={handleTogglePage(page.RowId)}
                        size="small"
                      />
                    }
                    label={`Page ${page.Page}`}
                  />
                );
              })}
            </FormGroup>
          ) : (
            <Typography variant="body1">
              There is no page available for selection
            </Typography>
          )}
        </Box>
      </Box>

      {sDetailItemData?.pageData
        ?.filter((page) => selectedPages.includes(page.RowId))
        ?.map((page, index) => (
          <Box key={page.RowId} mt={2}>
            {/* PAGE header bar */}
            <Paper
              elevation={1}
              sx={{ m: 1, p: 2, borderRadius: 4, bgcolor: "#fafcff" }}
            >
              <Box
                component={Paper}
                elevation={0}
                sx={{
                  bgcolor: "primary.light",
                  color: "white",
                  p: 1,
                  borderRadius: 1,
                  mb: 1,
                  textTransform: "uppercase",
                }}
              >
                {page.Title}
              </Box>

              <TableContainer
                sx={{
                  borderRadius: 2,
                  maxHeight: 420,
                  overflowY: "auto",
                  overflowX: "auto",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#c2e3faff transparent",
                  "&::-webkit-scrollbar": {
                    height: 8,
                    width: 8,
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "transparent",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#4e8fbd",
                    borderRadius: 4,
                  },
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                  sx={{
                    width: "100%",
                    tableLayout: "auto",
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                  }}
                >
                  <TableHead
                    sx={{
                      "& th": {
                        fontWeight: 700,
                        color: "black",
                        p: "6px",
                        borderBottom: "2px solid #e0e0e0",
                      },
                      "& .MuiTableCell-root": {
                        backgroundColor: "#f0f5ff",
                        color: "black",
                      },
                    }}
                  >
                    <TableRow sx={{ bgcolor: "grey.100" }}>
                      {itemsColumns?.map((col) => (
                        <TableCell
                          key={col.key}
                          align={col.align || "left"}
                          sx={{ fontWeight: 700, ...cellSx(col) }}
                        >
                          {col.header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody
                    sx={{
                      "& tr": {
                        backgroundColor: "white",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                        transition: "all 0.25s ease",
                        cursor: "pointer",
                      },
                    }}
                  >
                    {!page?.subData || page.subData?.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={itemsColumns.length}
                          align="center"
                          sx={{
                            py: 4,
                            color: "grey.600",
                            fontSize: "16px",
                            fontWeight: 600,
                            bgcolor: "#fafafa",
                          }}
                        >
                          No items available
                        </TableCell>
                      </TableRow>
                    ) : (
                      page.subData?.map((row, idx) => (
                        <TableRow
                          key={idx}
                          hover
                          sx={{
                            "& td": { padding: "6px" },
                            "& td:first-of-type": { borderTopLeftRadius: 12 },
                            "& td:last-of-type": { borderTopRightRadius: 12 },
                          }}
                        >
                          {itemsColumns?.map((col) => (
                            <TableCell
                              key={col.key}
                              align={col.align || "left"}
                              sx={cellSx(col)}
                            >
                              {col.render ? col.render(row, col) : row[col.key]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        ))}
    </Box>
  );
};

export default ItemVerfication;
